'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AjaxHelper = function () {
    function AjaxHelper() {
        var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'application/json; charset=UTF-8';
        (0, _classCallCheck3.default)(this, AjaxHelper);
        this.contentType = '';

        this.contentType = contentType;
    }

    (0, _createClass3.default)(AjaxHelper, [{
        key: 'sendRequest',
        value: function sendRequest(url) {
            var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'POST';

            var httpRequest = new XMLHttpRequest();

            httpRequest.onreadystatechange = function (ev) {
                if (httpRequest.readyState !== 4) return;

                if (httpRequest.status !== 200) {
                    console.error('Error requesting URL: ' + url + ', Status: ' + httpRequest.status + '.', httpRequest.responseText);
                } else if (handler && typeof handler === 'function') {
                    var responseObject = { responseParseFailed: false };
                    try {
                        responseObject = (0, _extends3.default)({}, responseObject, JSON.parse(httpRequest.responseText));
                    } catch (e) {
                        responseObject.responseParseFailed = true;
                        console.error('Error calling server through Ajax.', e);
                    }

                    handler(httpRequest, responseObject);
                }
            };
            httpRequest.open(type, url, true);
            httpRequest.setRequestHeader('Content-type', this.contentType);
            httpRequest.setRequestHeader('X-XSRF-TOKEN', _cookie2.default.getCookie('XSRF-TOKEN'));
            httpRequest.setRequestHeader('__RequestVerificationToken', _cookie2.default.getCookie('XSRF-TOKEN'));
            httpRequest.send((typeof body === 'undefined' ? 'undefined' : (0, _typeof3.default)(body)) === 'object' ? (0, _stringify2.default)(body) : body);
        }
    }]);
    return AjaxHelper;
}();

exports.default = AjaxHelper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/libraries/ajaxHelper.js
// module id = 442
// module chunks = 0 1